import { ReactComponent as EyeIcon } from 'assets/icons/eye16.svg'

import Styles from './ExternalResourceLoadingState.module.scss'

export const ExternalResourceEmptyState = () => {
  return (
    <>
      <div className={Styles.loadingStateContainer}>
        <div className={Styles.emptyPreviewContainer}>
          <div className={Styles.emptyPreviewIcon}>
            <EyeIcon />
          </div>
          <div className={Styles.emptyPreviewText}>
            <div>You will see a preview of the file when you add a link</div>
          </div>
        </div>
      </div>
    </>
  )
}
